import createReducer from 'lib/create-reducer'
import { constants } from './actions'
import saga from './sagas'

const defaultState = {
  id: '',
  name: '',
  displayName: '',
  normalizedName: '',
  description: '',
  slug: '',
  dashboardType: '',
  accessType: '',
  isPublic: null,
  componentLayout: [],
  doiQuery: {},
  journalMetadata: {},
  affiliationMetadata: {},
  institutionMetadata: {},
  haveAccessToDashboard: null,
  lastUpdated: null,
  doisUpdatedTS: null,
  doisRefreshedTS: null,
  refreshStatus: '',
  loadState: {},
  deleteDashboardError: false,
  deletingDashboard: false,
  totalDoiCount: 0,
  matchedDoiCount: 0,
  unmatchedDoiCount: 0,
  exportLoadTracker: {}
}

const customDashboard = createReducer(defaultState, {
  [constants.FETCH_DASHBOARD]: (state, { type, slug }) => ({
    ...state,
    loadState: {
      state: 'loading',
      key: [type, slug].join('-')
    }
  }),
  [constants.FETCH_DASHBOARD_SUCCESS]: (state, { type, slug, data }) => ({
    ...state,
    ...data,
    loadState: {
      state: 'loaded',
      key: [type, slug].join('-')
    },
    haveAccessToDashboard: true
  }),
  [constants.FETCH_DASHBOARD_FAILURE]: state => ({
    ...state,
    loadState: { state: 'error' }
  }),
  [constants.DELETE_CUSTOM_DASHBOARD]: state => ({
    ...state,
    deletingDashboard: true
  }),
  [constants.DELETE_CUSTOM_DASHBOARD_SUCCESS]: state => ({
    ...state,
    deletingDashboard: false
  }),
  [constants.DELETE_CUSTOM_DASHBOARD_FAILURE]: state => ({
    ...state,
    deleteDashboardError: true,
    deletingDashboard: false
  }),
  [constants.FLUSH_DASHBOARD]: (state) => ({
    ...defaultState
  }),

  [constants.EXPORT_DASHBOARD]: (state, { dashboardSlug }) => ({
    ...state,
    exportLoadTracker: {
      state: 'loading',
      key: dashboardSlug
    }
  }),
  [constants.EXPORT_DASHBOARD_FAILURE]: (state, error) => ({
    ...state,
    exportLoadTracker: {
      state: 'error',
      error
    }
  }),
  [constants.EXPORT_DASHBOARD_SUCCESS]: state => ({
    ...state,
    exportLoadTracker: {
      ...state.exportLoadTracker,
      state: 'loaded'
    }
  })
}, saga)

export default customDashboard
